import React from 'react';
import { PostDetail, Loader, TableOfContents, HorizontalCards, ChartTop3, AuthorBanner, DisclosureText, ChartSingleRow } from '@monorepo-nx/std-watch/ui';
import { getPostsBySubcategory, MedicalWebPageSEO, slugify, contentAPIRequest } from '@monorepo-nx/std-watch/services';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Layout } from '@monorepo-nx/std-watch/ui';
import { handlePageNotFound } from '@monorepo-nx/std-watch/services';
import { gql } from 'graphql-request';
import { MiniChart } from '@monorepo-nx/lander/ui';

const TOP_PROVIDER_PROMOTION_SLUG = "LetsGetChecked_default_LetsGetChecked"
const disclaimer = "The information provided herein does not constitute an expert or medical advice, nor intended to replace such advice."

const PostsPreview = ({ posts, title, viewAllLink, category, limit }) => {
    if(posts.length < 1) return null
    return (
        <div className=" mt-10">
            <h3 className="text-xl text-left mb-10">{title.replaceAll("_", " ")} </h3>
            {posts.slice(0, limit).map((post, index) => (
                // <FeatureArticle post={post} key={index}/>
                <HorizontalCards key={index} post={post} section={'readMoreArticles'} />
            ))}

            <div className="px-4 text-lg text-center mb-10">
                {/* {subCategories ? 
                <SubcategoryButtons subCategories={subCategories} category={category} />: null
                } */}

                <Link href={viewAllLink} legacyBehavior>
                    <a className=" font-bond text-indigo-500">
                        <span className="underline"> View All</span>  <span aria-hidden="true">&rarr;</span>
                    </a>
                </Link>
            </div>
        </div>
    )
}
export const Pill = ({ children }) => {
    return (
        <div
            className={"inline-flex  justify-between m-1 items-center rounded-full  px-2.5 py-0.5 text-sm text-cyan-800 font-normal bg-gray-100 hover:scale-110 ease-in-out duration-100"}
        >{children}
        </div>
    )
}
const PostHeader = ({ title, category, subCategory }) => {
    return (
        <div className='mb-10'>
            <h1 className="mb-2 text-left text-3xl ">{title}</h1>
            <DisclosureText text={disclaimer} />
            <Pill>{category?.replaceAll('_', ' ')}</Pill>
            <Pill>{subCategory?.replaceAll('_', ' ')}</Pill>

        </div>
    );
}

const PostPage = ({ params, post, moreGeneralPosts, articlesFromSameCategory, topProvider, mainMenu }) => {

    const router = useRouter();

    if (router.isFallback) {
        return <Loader />;
    }
    const categorySlug = slugify(post.category);
    return (
        <Layout mainMenu={mainMenu}>
            <div className="max-w-8xl break-words mx-auto px-2 lg:px-4 lg:py-12">
                <MedicalWebPageSEO data={post} />
                <div className="lg:grid h-fit lg:grid-cols-12">
                    <aside className="hidden sticky top-[100px] h-fit col-span-3 lg:block">
                        <TableOfContents />
                    </aside>
                    <div className="sm:col-span-7 sm:px-8">
                        <div className="flex justify-end lg:hidden z-10 sticky top-14 mt-2 ">
                            {/* Mobile */}
                            <TableOfContents />
                        </div>
                        <PostHeader {...post} />
                        <PostDetail post={post} />
                        <hr></hr>
                        {post.author ? <AuthorBanner author={post.author} createdAt={post.createdAt} /> : ""}

                        <hr className='m-4' ></hr>
                        
                        {post.subCategory && articlesFromSameCategory.length > 0 ? <PostsPreview viewAllLink={`/${categorySlug}`} posts={articlesFromSameCategory} title={`More from ${post.subCategory ?? post.subCategory}`} limit={3} /> : null}
                        {moreGeneralPosts.length > 0 ? <PostsPreview viewAllLink={`/blog`} posts={moreGeneralPosts} title={`You may also like`} limit={3} /> : null}
                        {/* Mobile */}
                        <div className="lg:hidden sm:mx-24 mb-16">
                            <div className='mb-16'>
                                <MiniChart />
                            </div>
                        </div>
                        <div className=" lg:block mb-10 ">
                            {post.category !== "Reviews" ? <ChartSingleRow promotion={topProvider} /> : null}
                        </div>
                    </div>
                    <aside className="hidden sticky top-[100px] h-fit lg:col-span-2 lg:block">
                        <MiniChart />
                    </aside>
                </div>
            </div>
        </Layout>
    );
};
export default PostPage;


// Fetch data at build time
export async function getServerSideProps({ req, res, params, query }) {

    res.setHeader(
        'Cache-Control',
        'public, s-maxage=72000, stale-while-revalidate=7200'
    )


    const stage = query.stage || 'PUBLISHED'

    // const post = await getPostDetails(params.slug, stage);
    
    query = gql`
        query GetPostView(
                $slug: String!,
                $stage: Stage!,
                $width: Int!,
                $footer: String,
                $menu: String!,
                $loadMoreLimit: Int!,
                $topProviderPromotionSlug: String,
        
            ) {
            post(where: {slug: $slug}, stage: $stage) {
                ...PostWithRTFFields
            }
            moreGeneralPosts: posts(first: $loadMoreLimit, stage: $stage) {
                ...PostFields
            }
            footerData: navigationMenu(where: {name: $footer}, stage: $stage) {
                ...NavigationMenuFields
            }
            mainMenuData: navigationMenu(where: {name: $menu}, stage: $stage) {
                ...NavigationMenuFields
            }
            topProvider: promotion(where: {slug: $topProviderPromotionSlug}, stage: $stage) {
                ...PromotionFields
            }
            siteConfig: siteConfig(where: {domain: "www.stdwatch.com"}){
                ...SiteConfigFields
            }
        }`
    
    const variables = {
        loadMoreLimit: 5,
        // category: post.category,
        slug: params.slug,
        stage: stage,
        footer: "Footer",
        menu: "Main",
        width: 500,
        topProviderPromotionSlug: TOP_PROVIDER_PROMOTION_SLUG,
        
    }
    const {
        post,
        moreGeneralPosts,
        mainMenuData,
        footerData,
        topProvider,
        siteConfig
        
     } = await contentAPIRequest(query, variables)
    
     if (!post) {
        return handlePageNotFound({ slug: params.slug })
    }
    // TODO: Move this to client side and lazyload it, it's not critical for preloading
    let articlesFromSameCategory = []
    if (post.category){
        articlesFromSameCategory = await getPostsBySubcategory(post.subCategory, 4)
    }

    
    return {
        props: {
            params: params,
            title: post.title,
            description: post.excerpt,
            seo: post.seo,
            post,
            moreGeneralPosts: moreGeneralPosts.filter((post) => post.slug !== params.slug),
            articlesFromSameCategory: articlesFromSameCategory.filter((post) => post.slug !== params.slug),
            mainMenu: mainMenuData.content,
            footer: footerData.content,
            topProvider,
            siteConfig
        },
    };
}

// Specify dynamic routes to pre-render pages based on data.
// The HTML is generated at build time and will be reused on each request.
// export async function getStaticPaths() {
//     const posts = await getPostsForPath();
//     return {
//         paths: posts.map(({ node: { slug } }) => ({ params: { slug } })),
//         fallback: 'blocking',
//     };
// }